<template>
  <div v-if="products.length > 0" class="combinados-con">
    <h2 class="section-title">Otras personas lo combinaron con</h2>
    <div
      v-for="p in products"
      :key="p.id"
      class="companion-row"
    >
      <div class="companion-main" @click="goToProduct(p)">
        <v-avatar size="56" rounded class="mr-3" v-if="!hasNoImage(p)">
          <v-img :src="p.detalle.srcImg" cover></v-img>
        </v-avatar>
        <div class="companion-info">
          <div class="companion-name">{{ p.nombre }}</div>
          <div class="companion-price">$ {{ p.precio }}</div>
        </div>
      </div>
      <v-btn
        v-if="p.tipo === 1"
        icon
        class="companion-add"
        :disabled="tiendaCerrada || isProductoAgotado(p)"
        @click.stop="addCompanion(p)"
      >
        <v-icon v-if="qtyInCart(p.id) === 0">mdi-plus</v-icon>
        <span v-else class="qty-badge">{{ qtyInCart(p.id) }}</span>
      </v-btn>
      <v-btn
        v-else
        icon
        class="companion-add"
        :disabled="tiendaCerrada || isProductoAgotado(p)"
        @click.stop="goToProduct(p)"
      >
        <v-icon>mdi-plus</v-icon>
      </v-btn>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import axios from '@/axios/axios-api.js'
import { isProductoAgotado as checkProductoAgotado } from '@/helpers/productoAgotado.js'

export default {
  name: 'CombinadosCon',
  props: {
    productoId: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      products: []
    }
  },
  computed: {
    ...mapGetters('App', ['tiendaCerrada']),
    ...mapGetters('Carrito', ['getItems'])
  },
  watch: {
    productoId: {
      immediate: true,
      handler () {
        this.load()
      }
    }
  },
  methods: {
    ...mapActions('Carrito', ['addItem']),
    async load () {
      this.products = []
      if (!this.productoId) return
      try {
        const { data } = await axios.get(`api/producto/${this.productoId}/combinados-con`, {
          params: { top: 5, dias: 90 }
        })
        this.products = Array.isArray(data) ? data : []
      } catch (e) {
        this.products = []
      }
    },
    hasNoImage (p) {
      return p && p.detalle && p.detalle.srcImg && p.detalle.srcImg.includes('noimage_Producto.png')
    },
    isProductoAgotado (p) {
      return checkProductoAgotado(p)
    },
    qtyInCart (id) {
      return (this.getItems || [])
        .filter(i => i.productId === id || i.id === id)
        .reduce((sum, it) => sum + (Number(it.cant) || 0), 0)
    },
    goToProduct (p) {
      if (checkProductoAgotado(p)) return
      const code = this.$clientCode()
      this.$router.push({ name: 'Producto', params: { client: code, id: p.id } })
    },
    addCompanion (p) {
      if (this.tiendaCerrada || checkProductoAgotado(p)) return
      this.addItem({
        id: p.id,
        nombre: p.nombre,
        tipo: p.tipo,
        cant: 1,
        totalPrice: p.precio,
        PrecioUnitario: p.precio,
        items: [],
        esCombinadoCombo: false,
        esSeleccion: false,
        detalle: p.detalle || { srcImg: null },
        Descuentos: p.Descuentos || [],
        GrupoDescuento: p.GrupoDescuento || null
      })
    }
  }
}
</script>
<style scoped>
.combinados-con {
  margin-top: 24px;
  padding: 0 4px;
}
.section-title {
  font-size: 1.15rem;
  font-weight: 800;
  margin: 0 0 12px;
}
.companion-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 0;
}
.companion-main {
  display: flex;
  align-items: center;
  flex: 1;
  min-width: 0;
  cursor: pointer;
}
.companion-name {
  font-weight: 600;
  line-height: 1.25;
}
.companion-price {
  margin-top: 2px;
  color: rgba(0, 0, 0, 0.65);
}
.companion-add {
  border: 1px solid rgba(0, 0, 0, 0.2) !important;
  background: #fff !important;
}
.qty-badge {
  font-weight: 700;
  font-size: 0.9rem;
}
</style>
